import { render } from "./team-members-list-footer.vue?vue&type=template&id=2213f982&scoped=true&ts=true"
import script from "./team-members-list-footer.vue?vue&type=script&lang=ts"
export * from "./team-members-list-footer.vue?vue&type=script&lang=ts"

import "./team-members-list-footer.vue?vue&type=style&index=0&id=2213f982&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213f982"]])

export default __exports__